$(document).on('submit', '.login-form', function(e){
  e.preventDefault();
  var headers = {
    'X-CSRF-TOKEN': $('input[name=_token]').val()
  }

  $('.error-message').remove();
  $('#login-alert').html('');

  var data = {
    email: $(".login-form input[name=email]").val(),
    password: $(".login-form input[name=password]").val(),
  }

  $.ajax({
    url: $(this).attr('action'),
    data: data,
    dataType: 'json',
    type: 'post',
    headers: headers,
    success: function(data){
      if (data.code == 'error') {
        $.each(data.fields, function(key, value){
          const error = `<span class="text-danger error-message">${value}</span>`;
          $('.login-form input[name='+key+']').after(error)
        })
      }
      else{
        $('#login-alert').html(data.fields)
        if (data.code == 'success') {

          setTimeout(function(){
dataLayer.push({
                event: "__sm__set_email",
                email_address: data.user.email,
                firstname: data.user.fname,
                lastname: data.user.lname
            });

            location.reload();
          }, 3000);
        }
      }

    }
  })
});
